export class KeyCodes {
    public static readonly Backspace = 8;
    public static readonly Tab = 9;
    public static readonly Enter = 13;
    public static readonly Shift = 16;
    public static readonly Control = 17;
    public static readonly Alt = 18;
    public static readonly Escape = 27;
    public static readonly Space = 32;
    public static readonly LeftArrow = 37;
    public static readonly UpArrow = 38;
    public static readonly RightArrow = 39;
    public static readonly DownArrow = 40;
    public static readonly Delete = 46;
    public static readonly Zero = 48;
    public static readonly One = 49;
    public static readonly Two = 50;
    public static readonly Three = 51;
    public static readonly Four = 52;
    public static readonly Five = 53;
    public static readonly Six = 54;
    public static readonly Seven = 55;
    public static readonly Eight = 56;
    public static readonly Nine = 57;
    public static readonly A = 65;
    public static readonly B = 66;
    public static readonly N = 78;
    public static readonly Q = 81;
    public static readonly R = 82;
    public static readonly Semicolon = 186;
    public static readonly Comma = 188;
    public static readonly Backtick = 192;
}
